import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted cookies
    const cookieConsent = document.cookie.split("; ").find((row) => row.startsWith("cookieConsent="));
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Set a cookie that expires in 30 days
    document.cookie = "cookieConsent=true; path=/; max-age=" + 30 * 24 * 60 * 60;
    setIsVisible(false);
  };

  const handleDecline = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 50, opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed bottom-6 left-6 z-50 right-6 bg-black bg-opacity-60 backdrop-blur-md text-white p-5 rounded-2xl shadow-xl flex flex-col md:flex-row items-center justify-between border border-yellow-600"
    >
      <div className="text-center md:text-left">
        <h3 className="text-lg font-bold text-yellow-500">🍪 Cookie Notice</h3>
        <p className="text-sm text-gray-300 mt-1">
          We use cookies to enhance your experience. By clicking "Accept," you agree to our cookie policy.
        </p>
        <p className="text-xs text-yellow-500 font-semibold mt-2">
          ⚠ Disclaimer: This is the only official website of SnapBucks. Beware of fraudulent sites.
        </p>
      </div>
      <div className="flex gap-3 mt-3 md:mt-0">
        <button
          onClick={handleAccept}
          className="bg-yellow-600 text-black px-5 py-2 rounded-full font-bold hover:bg-yellow-500 transition-all shadow-md"
        >
          Accept
        </button>
        <button
          onClick={handleDecline}
          className="bg-gray-700 text-white px-5 py-2 rounded-full hover:bg-gray-600 transition-all shadow-md"
        >
          Decline
        </button>
      </div>
    </motion.div>
  );
};

export default CookieConsent;
